const CURRENCY_SYMBOL_OVERRIDES: Readonly<Record<string, string>> = {
  TWD: 'NT$'
};

export function getCurrencySymbolOverride(
  currency: string
): string | undefined {
  return CURRENCY_SYMBOL_OVERRIDES[currency.toUpperCase()];
}
